import { postRequest } from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";
import { getAuthToken } from "../../utils/tokenUtils";

// -----------------------------------
// DOCUMENT MASTER API's
// -----------------------------------
export const AddDocument = async ({ name, status, kyc_applicable, is_required, group }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}document-master/create`,
      data: { name, status, kyc_applicable, is_required, group },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error('AddDocument Error:', error);
    throw error;
  }
};

export const fetchDocument = async () => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}document-master/list`,
      data: {}, // Empty data object for consistency
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error('fetchDocument Error:', error);
    throw error;
  }
};

export const ViewDocument = async ({ id }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}document-master/view`,
      data: { id },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error('ViewDocument Error:', error);
    throw error;
  }
};

export const updateDocument = async ({ id, payload }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}document-master/update`,
      data: {
        id,
        ...payload
      },
      headers: { Authorization: `Bearer ${token}` }
    });
    return response;
  } catch (error) {
    console.error('updateDocument Error:', error);
    throw error;
  }
};
